
// isAdmin: Esta función extrae los permisos del localStorage y comprueba si tiene
// las rutas permitidas de un admin.

export const userIsAdmin = () => {
    let rutasPermitidas = JSON.parse(localStorage.getItem("permisos"));
    
    //Buscar entre las rutas una que sea para administrar Usuarios.
    let rutaUsuarios = rutasPermitidas.filter((ruta) => ruta === "/Usuarios");

    if(rutaUsuarios.length > 0){ //Si posee la ruta, es admin.
        /* console.log("este usuario puede asignar porque es ADMIN", rutaUsuarios); */
        return true; //Retornar true.
    }
    return false; //Si no, retornar false.
};